import React, {Fragment} from 'react'
// import Config from '../launch/config'

import './css/resources-info.css'

const ResourcesInfo = () => {
    return (
        <Fragment>
            <div className="resources-info__preview">
                <img
                    alt="resource"
                    className="resources-info__preview-img"
                    src={`${process.env.PUBLIC_URL}/img/resources-green.png`}
                />
            </div>
            <div className="resources-info__description">
                <h1 className="modal-heading">Resources</h1>
                <p>
                    Resources allow you to construct ships and satellites. They
                    can be gathered from destroying enemy ships, colonizing
                    planets, or mining colonized planets.
                </p>
            </div>
        </Fragment>
    )
}

export default ResourcesInfo
